import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const useCancelSoa = (
  isLoading,
  hasGeneratedSOA,
  transactionStatus,
  applicationStatus,
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const isStatusAllowed =
    ['PENDING', 'EXPIRED REFERENCE NUMBER'].indexOf(transactionStatus) > -1;

  const isApplicationStatusAllowed =
    ['COMPUTED'].indexOf(applicationStatus) > -1;

  const isAllowed = true && isStatusAllowed && isApplicationStatusAllowed;

  const showComponent = isAllowed && hasGeneratedSOA;

  const onHandleClick = e => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want to cancel this statement of account application?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const component = showComponent ? (
    <div className="mx-2">
      <button
        disabled={isLoading}
        onClick={onHandleClick}
        type="button"
        className="btn btn-danger font-weight-bold"
      >
        {isLoading && (
          <>
            <i className="fas fa-spinner fa-spin" />
            &nbsp;
          </>
        )}
        Cancel SOA
      </button>
    </div>
  ) : null;

  return {
    isAllowed,
    onHandleClick,
    component,
  };
};

export default useCancelSoa;
